import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

export type { MuiButtonProps as ButtonProps };

const Button = MuiButton;

export default Button;
